/* Article image captions. Added by Oleg @ IAKOE.
   Body images can't show their alt/title via CSS (img is a replaced element), so a
   prose image that stands on its own line is wrapped in a <figure> with a <figcaption>
   from its title (or alt). An image that shares its line with text or other images
   (a row of award logos, an icon in a sentence) stays inline exactly as the editor
   placed it, at its authored size. Inside [cols] every image becomes its own grid cell.
   Images inside the embedded blocks (recipe / products / newsletter / promo) are left
   alone. */

(function () {
  const INLINE = new Set(['A', 'STRONG', 'B', 'EM', 'I', 'SPAN', 'U']);
  const EMBEDS = '.ts-recipe--inline, .ts-inline-products, .ts-inline-newsletter, .ts-promo';

  // True when `parent` holds nothing but `child` (whitespace, &nbsp; and <br> ignored).
  function holdsOnly(parent, child) {
    for (const node of parent.childNodes) {
      if (node === child) continue;
      if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) continue;
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') continue;
      if (node.nodeType === Node.COMMENT_NODE) continue;
      return false;
    }
    return true;
  }

  // The image plus any inline wrappers (link, bold) that hold only this image.
  function outerInline(img) {
    let el = img;
    while (el.parentNode && INLINE.has(el.parentNode.tagName) && holdsOnly(el.parentNode, el)) {
      el = el.parentNode;
    }
    return el;
  }

  function isEmpty(el) {
    return !el.querySelector('img, video, iframe, svg') && !el.textContent.trim();
  }

  function makeFigure(img) {
    const fig = document.createElement('figure');
    fig.className = 'ts-article__figure';
    const caption = (img.getAttribute('title') || img.getAttribute('alt') || '').trim();
    return { fig, caption };
  }

  function addCaption(fig, caption) {
    if (!caption) return;
    const cap = document.createElement('figcaption');
    cap.className = 'ts-article__caption ia-font-body ia-uppercase';
    cap.textContent = caption;
    fig.appendChild(cap);
  }

  function wrap(img, body) {
    if (img.closest('.ts-article__figure') || img.closest(EMBEDS)) return;

    const cols = img.closest('.ts-cols');
    if (cols) {
      // grid cell: the figure sits directly in .ts-cols, before the block that held it
      let cell = img;
      while (cell.parentNode && cell.parentNode !== cols) cell = cell.parentNode;
      const el = outerInline(img);
      const { fig, caption } = makeFigure(img);
      cols.insertBefore(fig, cell);
      fig.appendChild(el);
      addCaption(fig, caption);
      if (cell !== el && isEmpty(cell)) cell.remove();
      return;
    }

    const el = outerInline(img);
    const host = el.parentNode;
    if (!host) return;

    const standalone =
      host === body ||
      ((host.tagName === 'P' || host.tagName === 'DIV') && holdsOnly(host, el));
    if (!standalone) return;

    const { fig, caption } = makeFigure(img);
    if (host === body) {
      host.insertBefore(fig, el);
    } else {
      // the paragraph becomes the figure; its alignment (text-align) carries over
      const style = host.getAttribute('style');
      if (style) fig.setAttribute('style', style);
      host.parentNode.insertBefore(fig, host);
      host.remove();
    }
    fig.appendChild(el);
    addCaption(fig, caption);
  }

  function run() {
    document.querySelectorAll('.ts-article__body').forEach((body) => {
      body.querySelectorAll('img').forEach((img) => wrap(img, body));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
